<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
        <el-breadcrumb-item>大体积混凝土监测</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="build-bar">
        <div class="line">
          <p
            style="
              border-left: 5px solid #018eed;
              padding-left: 1vh;
              display: flex;
              align-content: center;
              align-items: center;
            "
          >
            {{ addForm.partName }}
          </p>
        </div>
        <div class="line">
          <div class="w30">
            <span>结构部位：</span>
            <el-input v-model="addForm.partName" readonly></el-input>
          </div>
          <div class="w30">
            <span>砼强度等级：</span>
            <el-input v-model="addForm.strengthGrade" readonly></el-input>
          </div>
          <div class="w30">
            <span>配合比编号：</span>
            <el-input v-model="addForm.mixCoding" readonly></el-input>
          </div>
          <div class="w25">
            <span>砼数量（m³）：</span>
            <el-input v-model="addForm.concreteNum" readonly></el-input>
          </div>
          <div class="w25">
            <span>砼浇灌日期：</span>
            <el-input v-model="addForm.wateringDate" readonly></el-input>
          </div>
          <div class="w25">
            <span>砼浇灌温度（℃）：</span>
            <el-input
              v-model="addForm.wateringTemperature"
              readonly
              style="width: 5vw"
            ></el-input>
          </div>
          <div class="w25">
            <span>开始养护温度（℃）：</span>
            <el-input
              v-model="addForm.maintenTemperature"
              readonly
              style="width: 5vw"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="main-table">
        <div class="table-head">
          <el-date-picker
            v-model="search.date"
            type="date"
            value-format="yyyy-MM-dd"
            @change="doFilter"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
        <div style="width: 100%; height: calc(100% - 8vh); position: relative">
          <el-table
            :data="tableDataEnd"
            :span-method="objectSpanMethod"
            border
            height="100%"
            style="width: 100%"
          >
            <el-table-column prop="createDate" label="监测时间">
            </el-table-column>
            <el-table-column prop="label" label="监测类型" >
              
            </el-table-column>
            <el-table-column prop="name" label="监测位置"> </el-table-column>
             <el-table-column prop="tsSersorImei" label="设备号"> </el-table-column>
            <el-table-column prop="temperature" label="数据"> </el-table-column>
            <!-- <el-table-column label="操作">
              <template slot-scope="scope" v-if="!scope.row.createDate">
                <el-button
                  size="mini"
                  @click="handleEditEq(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDeleteEq(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <!-- 表单列表 -->
        <!-- <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination> -->
      </div>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
      title="编辑信息"
      :visible.sync="addVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        style="padding-right: 3vw"
        :rules="rules"
      >
        <el-form-item label="结构部位名称：" prop="partName">
          <el-input
            v-model="addForm.partName"
            placeholder="请输入结构部位名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼强度等级：" prop="strengthGrade">
          <el-input
            v-model="addForm.strengthGrade"
            placeholder="请输入序列号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="配合比编码：">
          <el-input
            v-model="addForm.mixCoding"
            placeholder="请输入配合比编码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼数量：" prop="concreteNum">
          <el-input
            v-model="addForm.concreteNum"
            placeholder="请输入砼数量"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="浇灌时间：" prop="wateringDate">
          <el-date-picker
            v-model="addForm.wateringDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="浇灌温度：">
          <el-input
            v-model="addForm.wateringTemperature"
            placeholder="请输入浇灌温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始养护温度：">
          <el-input
            v-model="addForm.maintenTemperature"
            placeholder="请输入开始养护温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVis = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 二维码弹出框 -->
    <!-- <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
            </div>
        </el-dialog> -->
    <!-- 添加温度测点 -->
    <el-dialog
      title="添加温度测点"
      :visible.sync="temperVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
      style="height: 100%"
    >
      <el-form
        :model="creatForm"
        ref="creatForm"
        label-width="200px"
        :label-position="labelPosition"
      >
        <el-form-item label="名称">
          <el-input
            style="width: 217px"
            v-model="creatForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="传感器设备号">
          <el-input
            style="width: 217px"
            v-model="creatForm.tsSersorImei"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测类型:">
          <el-select
            v-model="creatForm.tsSersorType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="temperVis = false">取 消</el-button>
        <el-button type="primary" @click="sumbitEquip('creatForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      // tableSn:'',
      tableDataEnd: [],
      // currentPage:1,
      // pageSize:10,
      // totalItems:0,
      groupId: '',
      dataText: '数据加载中...',
      addVis: false,
      labelPosition: 'right',
      addForm: {
        id: '',
        projectId: '',
        partName: '',
        strengthGrade: '',
        mixCoding: '',
        concreteNum: '',
        wateringDate: '',
        wateringTemperature: '',
        maintenTemperature: '',
        createBy: '',
      },
      creatForm: {
        name: '',
        tsDtuId: '',
        useId: '',
        tsSersorImei: '',
        createBy: '',
        tsSersorType: '',
        usedFor: '',
      },
      // uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
      // uploadHead1: {
      //     accessToken: util.session.get('token')
      // },
      rules: {
        partName: [
          { required: true, message: '请输入结构部位名称', trigger: 'blur' },
        ],
        strengthGrade: [
          { required: true, message: '请输入砼强度等级', trigger: 'blur' },
        ],
        concreteNum: [
          { required: true, message: '请输入砼数量', trigger: 'blur' },
        ],
        wateringDate: [
          { required: true, message: '请选择浇灌时间', trigger: 'blur' },
        ],
      },
      //二维码
      // codeVis:false,
      // codeUrl:'',
      // codeTit:'',
      // icon:'',//配电箱图
      // http:base.httpCtx,
      projectName: '',
      id: '',
      search: {
        date: util.myTime.getCurTime(),
        useId: '',
        projectId: '',
      },

      temperVis: false, //添加温度测点弹出框
      macList: [], //设备列表
      rulesEquip: {
        observationName: [
          { required: true, message: '请输入观测点名称', trigger: 'blur' },
        ],
        concreteId: [
          { required: true, message: '请选择设备', trigger: 'blur' },
        ],
      },
      types: [], //监测类型列表
      spanArr: [],
      pos: 0
    }
  },
  mounted() {
    var params = this.$route.params
    this.groupId = params.proId
    this.addForm.projectId = this.groupId
    this.id = params.id
    this.getData()
    this.getMixedInfo()
  },
  methods: {
    //获取详情
    getMixedInfo() {
      var that = this
      myHttp
        .selectConcreteProject({
          id: this.id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var data = resp.data.data.ConcreteProject || {}
            that.addForm.id = data.id
            that.addForm.tsDtuId = data.tsDtuId
            that.addForm.tsDtuSensorId = data.tsDtuSensorId
            that.addForm.partName = data.partName
            that.addForm.strengthGrade = data.strengthGrade
            that.addForm.mixCoding = data.mixCoding
            that.addForm.concreteNum = data.concreteNum
            that.addForm.wateringDate = data.wateringDate
            that.addForm.wateringTemperature = data.wateringTemperature
            that.addForm.maintenTemperature = data.maintenTemperature
            that.addForm.updateBy = util.session.get('user').id
            that.creatForm.tsDtuId = data.tsDtuId
          }
        })
    },
    //保存信息
    saveEdit() {
      var that = this
      this.addVis = true
      // that.addForm.updateBy = util.session.get('user').id
      // myHttp.updateConcreteProject(that.addForm).then(
      //     function(resp) {
      //         if (resp.data.code == '200') {
      //             that.$message.success('修改成功')
      //             that.mixVisible = false
      //             that.getData()
      //         } else {
      //             that.$message.error(resp.data.msg)
      //         }
      //     },
      //     function() {}
      // )
    },

    //获取列表
    getData() {
      var that = this
      this.search.projectId = this.groupId
      this.search.useId = this.id
      myHttp.selectConcrete(this.search).then(function (resp) {
        if (resp.data.code == '200') {
          console.log(resp)
            that.spanArr =[]
          var list = resp.data.data.TsSensorRecord 
          for (var i = 0; i < list.length; i++) {
            list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            if (i === 0) {
                that.spanArr.push(1)
                that.pos = 0
              } else {
                // 判断当前元素与上一个元素是否相同
                if (
                  list[i].createDate === list[i - 1].createDate
                ) {
                  that.spanArr[that.pos] += 1
                  that.spanArr.push(0)
                } else {
                  that.spanArr.push(1)
                  that.pos = i
                }
              }
          }     
           that.tableDataEnd = list 
          //   that.totalItems = resp.data.data.PageInfo.total
          if (that.tableDataEnd.length == 0) {
            that.dataText = '暂无数据'
          }
        } else {
          that.dataText = '暂无数据'
        }
      })
      // myHttp.selectConcreteProjectListPage({
      //     projectId:this.groupId,
      //     pageNum:this.currentPage,
      //     pageSize:this.pageSize
      // }).then(function(resp){
      //     console.log(resp)
      //     if(resp.data.code=='200'){
      //         var list = resp.data.data.PageInfo.list||[]
      //         for(var i=0;i<list.length;i++){
      //             list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
      //         }
      //         that.tableDataEnd = list
      //         that.totalItems = resp.data.data.PageInfo.total
      //         if (that.tableDataEnd.length == 0) {
      //             that.dataText = '暂无数据'
      //         }
      //     }else{
      //         that.dataText = '暂无数据'
      //     }
      // })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //查询
    doFilter() {
      this.currentPage = 1
      this.getData()
    },
    //字典表（检测类型）
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'concrete_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.types = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //添加
    addMac() {
      this.addVis = true
      this.addForm.id = ''
      this.addForm.partName = ''
      this.addForm.strengthGrade = ''
      this.addForm.mixCoding = ''
      this.addForm.concreteNum = ''
      this.dialogTitle = '添加'
      this.addForm.wateringDate = util.myTime.getCurTime()
      this.addForm.wateringTemperature = ''
      this.addForm.maintenTemperature = ''
    },
    //编辑
    handleEdit(index, row) {
      this.addVis = true
      this.addForm.id = row.id
      this.addForm.partName = row.partName
      this.addForm.strengthGrade = row.strengthGrade
      this.addForm.mixCoding = row.mixCoding
      this.addForm.concreteNum = row.concreteNum
      this.addForm.wateringDate = row.wateringDate
      this.addForm.wateringTemperature = row.wateringTemperature
      ;(this.dialogTitle = '修改'),
        (this.addForm.maintenTemperature = row.maintenTemperature)
    },
      //编辑
    handleEditEq(index, row) {
        this.getDict()
        this.temperVis=true
        this.creatForm.tsSersorImei = row.tsSersorImei
      // this.creatForm.tsDtuId = ''
        this.creatForm.useId = this.id
        this.creatForm.name = row.name
        this.creatForm.id = row.tsDtuSensorId
        this.creatForm.tsSersorType = row.tsSersorType
        this.creatForm.createBy = util.session.get('user').id
        this.creatForm.usedFor = 1
    },
    //删除
    handleDeleteEq(index,row){
        var that = this
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            myHttp.deleteTsDtuSensorCGQ({
                id: row.tsDtuSensorId,
                updateBy:util.session.get('user').id
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        })
    },
    //提交
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.addForm.id == '') {
            that.addForm.createBy = util.session.get('user').id
            myHttp.postConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addVis = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          } else {
            that.addForm.updateBy = util.session.get('user').id
            myHttp.updateConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addVis = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          }
        }
      })
    },

    //展示二维码
    erCode(index, row) {
      this.codeVis = true
      this.codeUrl = '/pages/equipCheck/equipCheck?snId=' + row.sn
      this.codeTit = row.location
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      // var flag = util.common.filterBtnMenu(row)
      // return flag
      return true
    },

    /**
     * 添加观测点
     */
    addTemper() {
      this.getDict()
      var that = this
      this.temperVis = true
      this.creatForm.id=''
      this.creatForm.tsSersorImei = ''
      // this.creatForm.tsDtuId = ''
      this.creatForm.useId = this.id
      this.creatForm.name = ''
      this.creatForm.tsSersorType = ''
      this.creatForm.createBy = util.session.get('user').id
      this.creatForm.usedFor = 1
      // myHttp.selectConcreteListByProjectId2({
      //     projectId:this.groupId,
      //     concreteProjectId:this.id
      // }).then(function(resp){
      //     if(resp.data.code=='200'){
      //         var list = resp.data.data.Concrete||[]
      //         that.macList = list
      //     }
      // })
    },
    /**
     * 提交观测点
     */
    sumbitEquip(formName) {
      var that = this
      console.log(this.creatForm.id)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.creatForm.id==''){
               myHttp.postTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.temperVis = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }else{
            that.creatForm.updateBy = util.session.get('user').id
             myHttp.updateTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.temperVis = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }
         

        }
      })
    },
   objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
  },
}
</script>

<style scoped>
.main {
  flex-wrap: wrap;
  align-content: flex-start;
}
.main-table {
  width: 100%;
  height: calc(100% - 20vh);
}
.build-bar {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  /* height: 6vh; */
  border-bottom: 3px solid #17b2fe;
  background: #fff;
  /* justify-content: space-between; */
  padding: 1vh 1vw;
  border-radius: 0.5vh;
}
.build-bar .line {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.build-bar .w30 {
  width: 33%;
  position: relative;
  height: 5vh;
  display: flex;
  align-content: center;
  align-items: center;
}
.build-bar .w25 {
  width: 25%;
  margin-top: 2vh;
  text-align: left;
}

.build-bar span {
  margin-left: 30px;
  white-space: nowrap;
  display: inline-block;
}

.build-bar > .el-input {
  width: 200px;
  font-size: 12px;
}
.build-bar > .el-button {
  margin-left: 30px;
  /* background-color: #17b2fe;
        border-color: #17b2fe; */
}
.erCode {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.table-head {
  width: 100%;
  height: 8vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  background: #fff;
  padding: 1vh;
}
.avatar {
  width: 100%;
}
</style>

<style>
@import '../../../assets/css/common.css';
</style>